import {useQuery, type UseQueryResult} from '@tanstack/react-query'

import type {GetTenantConfigResponse} from 'interfaces'
import {PBFFService} from 'services/api'

/** React Query key for `GET /tenant/config` (PBFF). */
export const TENANT_CONFIG_QUERY_KEY = 'getTenantConfig'

export interface UseTenantConfigQueryOptions {
  /**
   * When false, the query will not execute. Defaults to true.
   * This is useful for callers that may mount before auth is available.
   */
  enabled?: boolean
}

/**
 * Loads tenant config from the portal BFF. Callers decide how to interpret
 * `data` (e.g. residency gating) using `isSuccess` / error state as needed.
 */
export const useTenantConfigQuery = (
  options?: UseTenantConfigQueryOptions,
): UseQueryResult<GetTenantConfigResponse> =>
  useQuery<GetTenantConfigResponse>({
    queryKey: [TENANT_CONFIG_QUERY_KEY],
    queryFn: () => PBFFService.getTenantConfig(),
    enabled: options?.enabled ?? true,
  })
